import * as constants from './constants';
export function setupMarket() {
  window.MARKET_CONSTANTS = constants;
}